import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorOptionsCard } from '../components/processor-options-card'

interface GenericProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const GenericProcessorDetailsPage = ({ processor }: GenericProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="generic"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorOptionsCard processor={processor} />
        </>
    )
}

